import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full px-6 py-6" }
const _hoisted_3 = { class: "bg-white rounded-lg border border-gray-200 shadow-sm px-3 py-2 mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-x-4 gap-y-2" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = {
  key: 0,
  class: "bg-white rounded-xl shadow-lg border border-gray-200 p-6 mb-6"
}
const _hoisted_23 = { class: "nav nav-tabs border-b border-gray-200 mb-4" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "ml-2 text-sm" }
const _hoisted_26 = {
  key: 0,
  class: "bg-gray-50 rounded-lg p-4"
}
const _hoisted_27 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4" }
const _hoisted_28 = { class: "font-semibold" }
const _hoisted_29 = { class: "font-semibold" }
const _hoisted_30 = { class: "font-semibold" }
const _hoisted_31 = { class: "font-semibold" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 1,
  class: "bg-blue-50 border border-blue-200 rounded-lg p-4"
}
const _hoisted_36 = {
  key: 2,
  class: "bg-white rounded-xl shadow-lg border border-gray-200 p-6"
}

import { ref, reactive, onMounted, computed } from 'vue'
import { PageHeader } from '@/components'
import { getCampagnesByVendeur } from '@/api/campagnes'
import { useAuthStore } from '@/stores/auth'
import type { PromotionFilter, PromotionData, Campagne } from '@/types'
import {useRouter} from "vue-router";
import { getVendeurMarques } from '@/api/brands'
import { getCategoriesTree } from '@/api/categories'
import type { CategorieNode } from '@/types/categorie'
import { getProductsPage } from '@/api/produits'

// État réactif

export default /*@__PURE__*/_defineComponent({
  __name: 'PromotionLimiteeView',
  setup(__props) {

const isLoading = ref(false)
const campagnes = ref<Campagne[]>([])
const selectedCampagneId = ref<number | null>(null)
const authStore = useAuthStore()
const router = useRouter()

const filters = reactive<PromotionFilter>({
  reference: '',
  brand: '',
  soldBy: '',
  productsPerPage: '',
  displayBy: '',
  sortBy: '',
  category: '',
  subCategory: '',
  subSubCategory: '',
  creationPeriodStart: '',
  creationPeriodEnd: '',
  shootingId: ''
})

const promotionData = ref<PromotionData[]>([])

// ---- Dynamic filter options (DB-backed) ----
const brandOptions = ref<Array<{ id: string; number: number; name: string; isDefault: boolean }>>([])
const categoriesTree = ref<CategorieNode[]>([])
const soldByOptions = ref<string[]>([])

const level1Categories = computed(() => categoriesTree.value)
const level2Categories = computed(() => {
  const id = Number(filters.category) || null
  if (!id) return []
  const found = categoriesTree.value.find(c => c.id_categorie === id)
  return found?.children ?? []
})
const level3Categories = computed(() => {
  const id1 = Number(filters.category) || null
  const id2 = Number(filters.subCategory) || null
  if (!id1 || !id2) return []
  const level1 = categoriesTree.value.find(c => c.id_categorie === id1)
  const level2 = level1?.children?.find(c => c.id_categorie === id2)
  return level2?.children ?? []
})

// Charger les campagnes du vendeur
const loadCampagnes = async () => {
  try {
    isLoading.value = true
    if (authStore.user?.id_vendeur) {
      const result = await getCampagnesByVendeur(authStore.user.id_vendeur)
      campagnes.value = result
      
      // Sélectionner la première campagne par défaut
      if (result.length > 0 && !selectedCampagneId.value) {
        selectedCampagneId.value = result[0].id_campagne
      }
    }
  } catch (error) {
    // Erreur silencieuse
  } finally {
    isLoading.value = false
  }
}

// Fonction pour appliquer les filtres
const applyFilters = async () => {
  try {
    isLoading.value = true
    // Simulation d'un appel API
    await new Promise(resolve => setTimeout(resolve, 1000))
    // TODO: Implémenter la récupération des produits de la campagne sélectionnée
  } catch (error) {
    // Erreur silencieuse
  } finally {
    isLoading.value = false
  }
}

// Fonction pour exporter en Excel
const exportToExcel = async () => {
  try {
    // Simulation d'un export Excel
    await new Promise(resolve => setTimeout(resolve, 2000))

    alert('Export Excel terminé!')
  } catch (error) {
    alert('Erreur lors de l\'export Excel.')
  }
}

// Formater une date pour l'affichage
const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return ''
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('fr-FR')
}

// Lifecycle
onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth()
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: 'auth' })
    return
  }
  // Load campaigns and dynamic filter options in parallel
  await Promise.all([
    loadCampagnes(),
    (async () => {
      try {
        // Brands
        brandOptions.value = await getVendeurMarques()
      } catch (e) {
        console.warn('Unable to load brands', e)
        brandOptions.value = []
      }
      try {
        // Categories tree
        categoriesTree.value = await getCategoriesTree('fr')
      } catch (e) {
        console.warn('Unable to load categories tree', e)
        categoriesTree.value = []
      }
      try {
        // SoldBy options: derive distinct vendu_par values from products list (light page)
        const id_vendeur = authStore.user?.id_vendeur
        if (id_vendeur) {
          const page = await getProductsPage({ id_vendeur, take: 200, skip: 0, orderBy: 'id_produit', orderDir: 'DESC' })
          const distinct = Array.from(
            new Set(
              (page.items || [])
                .map((p: any) => p?.vendu_par ?? '')
                .filter((v: any) => typeof v === 'string' && v.length > 0)
            ),
          ) as string[]
          soldByOptions.value = distinct
        } else {
          soldByOptions.value = []
        }
      } catch (e) {
        console.warn('Unable to load soldBy options', e)
        soldByOptions.value = []
      }
    })(),
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageHeader), { title: "Promotion limitée" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "text-xs font-semibold text-gray-800 mb-2 flex items-center gap-2" }, [
          _createElementVNode("i", { class: "fas fa-filter text-blue-600 text-sm" }),
          _createTextVNode(" Filtrer la liste par ")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Référence ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.reference) = $event)),
                type: "text",
                placeholder: "Rechercher par référence",
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, null, 512), [
                [
                  _vModelText,
                  filters.reference,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Marque ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.brand) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "---", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandOptions.value, (b) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: b.number,
                    value: b.name
                  }, _toDisplayString(b.name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.brand]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Vendu par ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.soldBy) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "-- Vendu par --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(soldByOptions.value, (vp) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: vp || 'vide',
                    value: vp
                  }, _toDisplayString(vp || '—'), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, filters.soldBy]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Nombre de produits / page ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.productsPerPage) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, _cache[18] || (_cache[18] = [
                _createStaticVNode("<option value=\"\" data-v-7004297d>-- Nombre de produits --</option><option value=\"10\" data-v-7004297d>10</option><option value=\"25\" data-v-7004297d>25</option><option value=\"50\" data-v-7004297d>50</option><option value=\"100\" data-v-7004297d>100</option>", 5)
              ]), 512), [
                [_vModelSelect, filters.productsPerPage]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Afficher par ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.displayBy) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, _cache[20] || (_cache[20] = [
                _createElementVNode("option", { value: "" }, "-- Afficher par --", -1),
                _createElementVNode("option", { value: "date" }, "Date", -1),
                _createElementVNode("option", { value: "nom" }, "Nom", -1),
                _createElementVNode("option", { value: "prix" }, "Prix", -1)
              ]), 512), [
                [_vModelSelect, filters.displayBy]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Trier par ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.sortBy) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, _cache[22] || (_cache[22] = [
                _createElementVNode("option", { value: "" }, "-- Trier par --", -1),
                _createElementVNode("option", { value: "asc" }, "Croissant", -1),
                _createElementVNode("option", { value: "desc" }, "Décroissant", -1)
              ]), 512), [
                [_vModelSelect, filters.sortBy]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Catégorie ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.category) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "-- Choisir une catégorie --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level1Categories.value, (cat) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cat.id_categorie,
                    value: cat.id_categorie
                  }, _toDisplayString(cat.label), 9, _hoisted_14))
                }), 128))
              ], 512), [
                [
                  _vModelSelect,
                  filters.category,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Sous-catégorie ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.subCategory) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "-- Choisir une sous-catégorie --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level2Categories.value, (cat) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cat.id_categorie,
                    value: cat.id_categorie
                  }, _toDisplayString(cat.label), 9, _hoisted_16))
                }), 128))
              ], 512), [
                [
                  _vModelSelect,
                  filters.subCategory,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " SS-catégorie ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.subSubCategory) = $event)),
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, "-- Choisir une ss-catégorie --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level3Categories.value, (cat) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cat.id_categorie,
                    value: cat.id_categorie
                  }, _toDisplayString(cat.label), 9, _hoisted_18))
                }), 128))
              ], 512), [
                [
                  _vModelSelect,
                  filters.subSubCategory,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Début de création ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.creationPeriodStart) = $event)),
                type: "date",
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, null, 512), [
                [_vModelText, filters.creationPeriodStart]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " Fin de création ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.creationPeriodEnd) = $event)),
                type: "date",
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, null, 512), [
                [_vModelText, filters.creationPeriodEnd]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-xs font-medium text-gray-700 mb-1" }, " ID shooting ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.shootingId) = $event)),
                type: "text",
                placeholder: "ID Shooting",
                class: "w-full h-9 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white"
              }, null, 512), [
                [
                  _vModelText,
                  filters.shootingId,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", { class: "flex justify-end gap-2 mt-3" }, [
            _createElementVNode("button", {
              type: "button",
              onClick: applyFilters,
              class: "inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            }, _cache[33] || (_cache[33] = [
              _createElementVNode("i", { class: "fas fa-search mr-1" }, null, -1),
              _createTextVNode(" Filtrer ")
            ])),
            _createElementVNode("button", {
              type: "button",
              onClick: exportToExcel,
              class: "inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-md bg-green-600 text-white hover:bg-green-700 transition-colors"
            }, _cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "fas fa-download mr-1" }, null, -1),
              _createTextVNode(" Exporter en Excel ")
            ]))
          ])
        ], 32)
      ]),
      (campagnes.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2" }, [
              _createElementVNode("i", { class: "fas fa-tags text-blue-600" }),
              _createTextVNode(" Liste des campagnes de promotion limitée ")
            ], -1)),
            _createElementVNode("ul", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campagnes.value, (campagne) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: campagne.id_campagne,
                  class: "inline-block mr-2"
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (selectedCampagneId.value = campagne.id_campagne),
                    class: _normalizeClass([
                'px-4 py-2 rounded-t-lg transition-colors',
                selectedCampagneId.value === campagne.id_campagne
                  ? 'bg-blue-600 text-white font-semibold'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              ])
                  }, [
                    _createTextVNode(" #" + _toDisplayString(campagne.id_campagne) + ": " + _toDisplayString(campagne.titre || 'Sans titre') + " ", 1),
                    _createElementVNode("span", _hoisted_25, " (" + _toDisplayString(campagne.nb_produits) + " produit" + _toDisplayString(campagne.nb_produits > 1 ? 's' : '') + ") ", 1)
                  ], 10, _hoisted_24)
                ]))
              }), 128))
            ]),
            (selectedCampagneId.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campagnes.value, (campagne) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: campagne.id_campagne
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Date de début", -1)),
                          _createElementVNode("p", _hoisted_28, _toDisplayString(formatDate(campagne.debut)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Date de fin", -1)),
                          _createElementVNode("p", _hoisted_29, _toDisplayString(formatDate(campagne.fin)), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Nombre de produits", -1)),
                          _createElementVNode("p", _hoisted_30, _toDisplayString(campagne.nb_produits), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Réduction", -1)),
                          _createElementVNode("p", _hoisted_31, [
                            (campagne.valeur_min && campagne.valeur_max)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(campagne.valeur_min) + "% - " + _toDisplayString(campagne.valeur_max) + "% ", 1))
                              : (campagne.valeur_min)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(campagne.valeur_min) + "% ", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_34, "N/A"))
                          ])
                        ])
                      ])
                    ])), [
                      [_vShow, selectedCampagneId.value === campagne.id_campagne]
                    ])
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[41] || (_cache[41] = [
              _createElementVNode("div", { class: "flex items-center gap-3" }, [
                _createElementVNode("i", { class: "fas fa-info-circle text-blue-600" }),
                _createElementVNode("p", { class: "text-blue-800" }, "Aucune campagne programmée")
              ], -1)
            ])))
          : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[42] || (_cache[42] = [
            _createElementVNode("div", { class: "flex items-center justify-center gap-3" }, [
              _createElementVNode("i", { class: "fas fa-spinner fa-spin text-blue-600" }),
              _createElementVNode("p", { class: "text-gray-700" }, "Chargement des campagnes...")
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})